
/* styles */
var cssModules = {}
cssModules["$style"] = require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true,\"localIdentName\":\"[hash:base64]_0\",\"modules\":true,\"importLoaders\":true}!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-51beda60!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Contact.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Contact.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-51beda60!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Contact.vue"),
  /* scopeId */
  null,
  /* cssModules */
  cssModules
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/Contact.vue
// module id = 107
// module chunks = 2